import { render, staticRenderFns } from "./ViewRequestedToPage.vue?vue&type=template&id=171ed904&scoped=true&"
import script from "./ViewRequestedToPage.vue?vue&type=script&lang=js&"
export * from "./ViewRequestedToPage.vue?vue&type=script&lang=js&"
import style0 from "./ViewRequestedToPage.vue?vue&type=style&index=0&id=171ed904&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171ed904",
  null
  
)

export default component.exports